/**
 * App.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React, { Component } from 'react';
import './App.css';

import MediaQuery from 'react-responsive';

import CssBaseline from '@material-ui/core/CssBaseline';

// Sxa Components
import SxaAssessmentRootTile from './SxaAssessmentRootTile';
import SxaAssessmentPortraitTile from './SxaAssessmentPortraitTile';

class App extends Component {

  state = {
      ass: {},
      isLoading: false,
      loaded: false
  };

  // OLD - no wait - relies on render being called until state shows up...
  componentDidMount() {
      //console.log("App.componentDidMount()");

      // Check loaded flag - avoid repeat loads
      //console.log("App.componentDidMount(): loaded = " + this.state.loaded);
      if (this.state.loaded === true) {
          console.log("Assessment is loaded.");
          return;
      }

      //console.log("App.componentDidMount(): isLoading = " + this.state.isLoading);
      if (this.state.isLoading === true) {
          console.log("Assessment is loading...");
          return;
      }

      // Set custom document title "StratexAssess"
      document.title = "StratexAssess";

      this.setState({isLoading: true, loaded: false});

      // Get assessment for the session (implicit or explicit)
      // FIXME - change to sxa/v1/assessment
      console.log("Fetching Assessment from SXA server at api/assessment");

      // Require ES6 Promise and polyfill
      var ES6Promise = require("es6-promise");
      ES6Promise.polyfill();
      // Require Axios
      var axios = require("axios");

      var url = 'api/assessment';
      axios.get(url)
          .then(response => {
              console.log("Processing response A data");
              //console.log(response.data);

              this.setState({
                  ass: response.data,
                  isLoading: false,
                  loaded: true
              });
          })
          .catch(error => {
              console.log("Failed to get Assessment, error = " + error);
              //this.setState({error, isLoading: false, loaded: false})
          })
  }

  // Callback function used by child to signal Q-score change
  signalAChange = (a) => {
      //console.log("signalAChange(): new A state = " + a.progressState);

      // Update the App level A object
      this.setState( state => ({ ass: a }) );
  }

  render() {
      const {ass, isLoading, loaded} = this.state;

      //console.log("App.render(): isLoading = " + isLoading);
      if (isLoading === true) {
          return <p>Loading...</p>;
      }

      //console.log("App.render(): loaded = " + loaded);
      if (loaded === false) {
          return <p>Not loaded yet...</p>;
      }

      if(!ass.oid) {
          return <p>Failed to load Assessment data. Please check the connection and try again.</p>;
      }

      // Debug trace
      //console.log("App.render(): Proceeding with ass = " + ass.oid);

      return (
          <MediaQuery minWidth={992}>
              { matches => {
                  return matches ?
                      <React.Fragment>
                          <CssBaseline />
                          { this.state.ass ? (
                              <div className='App'>
                                  <SxaAssessmentRootTile ass={ass}
                                                         signalAChange={this.signalAChange}
                                  />
                              </div>
                          ) : "No Assessment found"}
                      </React.Fragment>
                      :
                      <React.Fragment>
                          <CssBaseline />
                          { this.state.ass ? (
                              <div className='App'>
                                  <SxaAssessmentPortraitTile ass={ass}
                                                             signalAChange={this.signalAChange}
                                  />
                              </div>
                          ) : "No Assessment found"}
                      </React.Fragment>
                }
              }
          </MediaQuery>
      );
  }
}

export default App;
